<div [style.display]="type !== 'type1' && 'none'" ngClass="{{ data.customClass }}">
    
    <div class="adc-tab-view">
      <div class="adc-tab-nav">
        <div class="adc-tab-button adc-tab-bs1" 
             *ngFor="let tab of data; let i = index" 
             #tabButton
             [attr.data-tab-target]="tab.tabTarget"
             (click)="activateTab(tab.tabTarget)">
          {{ tab.tabTitle }}
        </div>
      </div>
    
      <div class="adc-tab-content">
        <div class="adc-tab-pane adc-tab-ps1" 
             *ngFor="let tab of data" 
             #tabContent
             [attr.data-tab-name]="tab.tabTarget"
             [class.active]="tab.tabTarget === activeTab">
          {{ tab.tabContent }}
        </div>
      </div>
    </div>
</div>


<div [style.display]="type !== 'type2' && 'none'" ngClass="{{ data.customClass }}">
    <div class="adc-tab-view">
        <div class="adc-tab-nav">
          <nav aria-label="adc-breadcrumb ">
            <ul class="adc-breadcrumb4 adc-w-100">
                <li class="adc-tab-button adc-tab-bs4" #tabButton [attr.data-tab-target]="tab.tabTarget" [ngClass]="{'adc-breadcrumb-item-active3': breadcrumbActive == 'breadcrumb1'}" (click)="toggleActive('breadcrumb1')" *ngFor="let tab of data"><a>{{ tab.tabTitle }}</a></li>
                <!-- <li class="adc-tab-button adc-tab-bs4" data-tab-target="tab2" [ngClass]="{'adc-breadcrumb-item-active3': breadcrumbActive == 'breadcrumb2'}" (click)="toggleActive('breadcrumb2')"><a>Step 2</a></li>
                <li class="adc-tab-button adc-tab-bs4" data-tab-target="tab3" [ngClass]="{'adc-breadcrumb-item-active3': breadcrumbActive == 'breadcrumb3'}" (click)="toggleActive('breadcrumb3')"><a>Step 3</a></li>
                <li class="adc-tab-button adc-tab-bs4" data-tab-target="tab4" [ngClass]="{'adc-breadcrumb-item-active3': breadcrumbActive == 'breadcrumb4'}" (click)="toggleActive('breadcrumb4')"><a>Step 4</a></li>
                <li class="adc-tab-button adc-tab-bs4" data-tab-target="tab5" [ngClass]="{'adc-breadcrumb-item-active3': breadcrumbActive == 'breadcrumb5'}" (click)="toggleActive('breadcrumb5')"><a>Step 5</a></li> -->
            </ul>
          </nav>
        </div>
        <div class="adc-tab-content adc-position-relative">
          <div *ngIf="loading" class="adc-w-100 adc-h-100 adc-position-absolute adc-d-flex adc-justify-content-center adc-align-items-center" style="z-index: 100; background-color: white;">
            <div class="loader4"></div>
          </div>
          <div class="adc-tab-pane adc-tab-ps1" #tabContent *ngFor="let tab of data" [attr.data-tab-name]="tab.tabTarget">
            {{ tab.tabContent }}
          </div>
          <!-- <div class="adc-tab-pane adc-tab-ps1" data-tab-name="tab2">
            2Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut modi, sed assumenda aliquid enim, pariatur rerum necessitatibus dolorem impedit quisquam quidem suscipit omnis nihil aspernatur, obcaecati dicta harum ipsum officiis?
          </div>
          <div class="adc-tab-pane adc-tab-ps1" data-tab-name="tab3">
            3Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam architecto aspernatur repellat minima deleniti odit? Reprehenderit rerum similique atque officiis alias maxime soluta possimus? Impedit voluptate in quis perspiciatis laudantium.
          </div>
          <div class="adc-tab-pane adc-tab-ps1" data-tab-name="tab4">
            4Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam architecto aspernatur repellat minima deleniti odit? Reprehenderit rerum similique atque officiis alias maxime soluta possimus? Impedit voluptate in quis perspiciatis laudantium.
          </div>
          <div class="adc-tab-pane adc-tab-ps1" data-tab-name="tab5">
            5Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam architecto aspernatur repellat minima deleniti odit? Reprehenderit rerum similique atque officiis alias maxime soluta possimus? Impedit voluptate in quis perspiciatis laudantium.
          </div> -->
        </div>
    </div>
</div>
